"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withNativeListener = exports.NativeListener = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const events = [
    'keydown',
    'keypress',
    'keyup',
    'click',
    'contextmenu',
    'dblclick',
    'drag',
    'dragend',
    'dragenter',
    'dragexit',
    'dragleave',
    'dragover',
    'dragstart',
    'drop',
    'focus',
    'touchstart',
    'touchmove',
    'touchend',
    'mousedown',
    'mouseenter',
    'mouseleave',
    'mousemove',
    'mouseout',
    'mouseover',
    'mouseup',
    'wheel',
];
class NativeListenerForRef extends react_1.Component {
    constructor(props) {
        var _a;
        super(props);
        this.name = (_a = props.name) !== null && _a !== void 0 ? _a : 'NativeListener';
        if (!props.children || props.children.length > 0) {
            throw new Error(`${this.name} has to wrap exactly one element`);
        }
        this.elem = (0, react_1.createRef)();
        this.allRefs = (node) => {
            const { children, forwardedRef } = this.props;
            this.elem.current = node;
            if (forwardedRef) {
                ;
                forwardedRef.current = node;
            }
            if (children.ref) {
                ;
                children.ref.current = node;
            }
        };
        this.listeners = {};
        this.assignEvents();
    }
    assignEvents() {
        events.forEach((evName) => {
            const listener = this.props[evName];
            if (typeof listener === 'function') {
                this.listeners[evName] = listener;
            }
        });
    }
    componentDidMount() {
        var _a;
        for (const evName in this.listeners) {
            if ((0, utils_1.has)(this.listeners, evName)) {
                (_a = this.elem.current) === null || _a === void 0 ? void 0 : _a.addEventListener(evName, this.listeners[evName]);
            }
        }
    }
    componentDidUpdate() {
        var _a, _b;
        for (const evName in this.listeners) {
            if ((0, utils_1.has)(this.listeners, evName)) {
                (_a = this.elem.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(evName, this.listeners[evName]);
            }
        }
        this.listeners = {};
        this.assignEvents();
        for (const evName in this.listeners) {
            if ((0, utils_1.has)(this.listeners, evName)) {
                (_b = this.elem.current) === null || _b === void 0 ? void 0 : _b.addEventListener(evName, this.listeners[evName]);
            }
        }
    }
    componentWillUnmount() {
        var _a;
        for (const evName in this.listeners) {
            if ((0, utils_1.has)(this.listeners, evName)) {
                (_a = this.elem.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(evName, this.listeners[evName]);
            }
        }
    }
    render() {
        const { children } = this.props;
        return (0, react_1.cloneElement)(children, { ref: this.allRefs });
    }
}
exports.NativeListener = (0, react_1.forwardRef)((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(NativeListenerForRef, Object.assign({}, props, { forwardedRef: ref }, { children: children })));
});
const withNativeListener = (element, listeners) => (0, jsx_runtime_1.jsx)(exports.NativeListener, Object.assign({}, listeners, { children: element }));
exports.withNativeListener = withNativeListener;
